import React from 'react'

import { IconProps } from './types'

const InformationCircle: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    fill="none"
    stroke={color}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
)
InformationCircle.displayName = 'InformationCircle'
InformationCircle.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default InformationCircle
